export const MAX_THIRD_LEVEL_ITEMS = 10;
